module.exports = __webpack_public_path__ + "img/max-file-content-repeat.a2340064.svg";